import React, { useState, useEffect } from "react";
import { Rnd } from "react-rnd";
import { Input, Checkbox, Button } from "antd";

import DeleteElement from "../components/DeleteElement";

const TodoListRectangle = (props) => {
  const { data, saveNewDimensions } = props;

  const [width, setWidth] = useState(data.width);
  const [height, setHeight] = useState(data.height);
  const [x, setX] = useState(data.x);
  const [y, setY] = useState(data.y);
  const [items, setItems] = useState(
    data.items || [{ text: "", checked: false }]
  );
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(data.text || "--");
  const [title, setTitle] = useState(data.title || "--");

  const addItem = () => {
    setItems([...items, { text: "", checked: false }]);
  };

  const handleChange = (index) => {
    saveNewDimensions(index, {
      id: index,
      text,
      items,
      x,
      y,
      title,
    });
  };

  const handleTextChange = (index, event) => {
    const newItems = [...items];
    newItems[index].text = event.target.value;

    // Wenn der Text leer ist, entferne das Item
    if (event.target.value === "") {
      newItems.splice(index, 1);
    }
    setItems(newItems);
    handleChange(index);
  };

  const handleCheckboxChange = (index, event) => {
    const newItems = [...items];
    newItems[index].checked = event.target.checked;
    setItems(newItems);
    handleChange(index);
  };

  return (
    <DeleteElement id={data.id}>
      <Rnd
        cancel="input,textarea,button,select,option"
        style={{
          padding: "10px",
          border: "solid 1px",
          background: "#959595",
          wordWrap: "break-word",
          overflow: "hidden",
        }}
        size={{ width, height }}
        position={{ x, y }}
        //disableDragging={isEditing}
        onDragStop={(e, d) => {
          setX(d.x);
          setY(d.y);
          saveNewDimensions(data.id, {
            id: data.id,
            text,
            items,
            x: d.x,
            y: d.y,
            title,
          });
        }}
        onResizeStop={(e, direction, ref, delta, position) => {
          setWidth(ref.style.width);
          setHeight(ref.style.height);
          setX(position.x);
          setY(position.y);
          saveNewDimensions(data.id, {
            id: data.id,
            text,
            items,
            x: position.x,
            y: position.y,
            width: ref.style.width,
            height: ref.style.height,
            title,
          });
        }}
        resizeGrid={[20, 20]}
        dragGrid={[20, 20]}
      >
        <div>
          {items.map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <Checkbox
                checked={item.checked}
                onChange={(event) => handleCheckboxChange(index, event)}
              />
              <Input
                value={item.text}
                onChange={(event) => handleTextChange(index, event)}
                bordered={false}
                style={{ marginLeft: 8 }}
                placeholder="Text eingeben"
              />
            </div>
          ))}
          <Button type="dashed" onClick={addItem}>
            +
          </Button>
        </div>
      </Rnd>
    </DeleteElement>
  );
};

export default TodoListRectangle;
